import Cookies from 'js-cookie';
import utils from './utils';
import User from './user';
import Request from './request';

class Store {
  constructor() {
    let userInfo;
    try {
      userInfo = JSON.parse(window.localStorage.getItem('login'));
    } catch (error) {
      console.debug('user not login');
    }
    if (userInfo && userInfo.id) {
      this.user = new User(userInfo);
    }
  }

  async dispatch(action) {
    if (!action || !action.type) {
      console.warn(`ACTION not exists please check ${action}`);
    }
    switch (action.type) {
      case 'updateUser':
        this.updateUser();
        break;
      case 'updateNotification':
        await this.updateNotification();
        break;
      default:
        break;
    }
  }

  async updateNotification() {
    const notifications = await Request.call('getNotifications');
    if (notifications) {
      this.notifications = notifications;
    }
  }

  async updateUser() {
    const userInfo = await Request.call('getUserStatus');
    if (userInfo && userInfo.id) {
      this.user = new User(userInfo);
      document.querySelector('.mt-1').textContent = this.user.userDesc;
      window.localStorage.setItem('login', JSON.stringify(userInfo));
      Cookies.set('miao-token', userInfo.token, {
        domain: `.${window.location.host
          .split('.')
          .slice(-2)
          .join('.')}`,
      });
    }
    utils.injectMarketTool(userInfo);
  }

  logout() {
    window.localStorage.setItem('login', null);
    Cookies.remove('miao-token', {
      domain: `.${window.location.host
        .split('.')
        .slice(-2)
        .join('.')}`,
    });
  }
}

const store = new Store();

export default store;
